<template>
    <div class="charter">
        <home-nav :showInput="showInput"></home-nav>
        <div class="search-box-cahrter">
            <div class="search-box-cahrter-in">
                <el-autocomplete
                        v-model="state"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入内容"
                        @select="handleSelect"
                        :value="search"
                >
                    <i class="el-icon-search el-input__icon"
                       style="color: #FF5227;cursor: pointer;"
                       slot="suffix"
                       @click="handleIconClickCharter">
                    </i>
                </el-autocomplete>
            </div>
        </div>
        <div class="charter-box">
            <div class="charter-box-left">
                <div class="charter-select-box">
                    <div class="charter-select-area">
                        <div class="charter-select-area-title">
                            车辆类型
                        </div>
                        <div class="charter-select-area-list">
                            <div class="area-list-single"
                                 v-for="(item,index) in typeList"
                                 :key="index"
                                 @click="typeClick(index)"
                                 :class="typeNumber == index ? 'area-list-single-ac' : ''"
                            >
                                {{ item.text }}
                            </div>
                        </div>
                    </div>

                    <div class="charter-select-area">
                        <div class="charter-select-area-title-fwqy">
                            服务区域
                        </div>
                        <div class="charter-select-area-list">
                            <div class="area-list-single"
                                 v-for="(item,index) in serviceArea"
                                 :key="index"
                                 @click="serviceAreaClick(index)"
                                 :class="serviceAreaNumber == index ? 'area-list-single-ac' : ''"
                            >
                                {{ item.text }}
                            </div>
                        </div>
                    </div>

                    <!--暂时去掉-->
                    <!--<div class="charter-select-area">
                        <div class="charter-select-area-title">
                            车队性质
                        </div>
                        <div class="charter-select-area-list">
                            <div class="area-list-single"
                                 v-for="(item,index) in natureList"
                                 :key="index"
                                 @click="natureClick(index)"
                                 :class="natureNumber == index ? 'area-list-single-ac' : ''"
                            >
                                {{ item.text }}
                            </div>
                        </div>
                    </div>-->

                    <div class="charter-select-area">
                        <div class="charter-select-area-title">
                            服务保障
                        </div>
                        <div class="charter-select-area-list">
                            <!--<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                         @change="handleCheckAllChange">全选
                            </el-checkbox>-->
                            <div class="select-all" @click="selectAll"
                                 :class="selectAllCheck ? 'area-list-single-ac' : ''">全部
                            </div>
                            <div class="select-all-list">
                                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                                    <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
                                </el-checkbox-group>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="charter-sort">
                    <!--循环版本-->
                    <!--<div class="charter-sort-list"
                         v-for="(item,index) in sortList"
                         :key='index'
                         @click="sortClick(index)"
                         :class="sortNumber == index ? 'charter-sort-list-ac' : ''"
                    >
                        <span>{{ item.text }}</span>
                        <img :src="sortNumber == index ? jiangIcon : morenIcon" alt="">
                    </div>-->

                    <!--非循环版本-->
                    <div class="charter-sort-list"
                         :class="sortNumberClick == 0 ? 'charter-sort-list-ac' : ''"
                         @click="sortClickIdx(0)"
                    >
                        <span>综合服务</span>
                        <!-- <img :src="sortNumberClick == 0 ? (downIcon0 ? jiangIcon : shengIcon) : morenIcon" alt=""> -->
                    </div>
                    <div class="charter-sort-list"
                         :class="sortNumberClick == 1 ? 'charter-sort-list-ac' : ''"
                         @click="sortClickIdx(1)"
                    >
                        <span>服务人数</span>
                        <img :src="sortNumberClick == 1 ? (downIcon1 ? jiangIcon : shengIcon) : morenIcon" alt="">
                    </div>
                    <div class="charter-sort-list"
                         :class="sortNumberClick == 2 ? 'charter-sort-list-ac' : ''"
                         @click="sortClickIdx(2)"
                    >
                        <span>好评率</span>
                        <img :src="sortNumberClick == 2 ? (downIcon2 ? jiangIcon : shengIcon) : morenIcon" alt="">
                    </div>
                    <div class="charter-sort-list"
                         :class="sortNumberClick == 3 ? 'charter-sort-list-ac' : ''"
                         @click="sortClickIdx(3)"
                    >
                        <span>响应速度</span>
                        <img :src="sortNumberClick == 3 ? (downIcon3 ? jiangIcon : shengIcon) : morenIcon" alt="">
                    </div>
                </div>

                <div class="charter-team-list" v-show="getcdList.length">
                    <div class="team-list-box"
                         v-for="(item,index) in getcdList"
                         :key="index"
                         @click="teamClick(item.id,item.company_pic,item.company_name)"
                    >
                        <div class="team-list-box-left">
                            <img :src="item.company_pic" alt="">
                        </div>
                        <div class="team-list-box-middle">
                            <p class="team-title">
                                {{ item.title }}
                            </p>
                            <div class="team-detail">
                                <div class="team-detail-star">
                                    <el-rate
                                            v-model="item.star"
                                            disabled
                                            text-color="#ff9900"
                                            :colors=scoreColors
                                            disabled-void-color="#888">
                                    </el-rate>
                                </div>
                                <div class="team-detail-lv" v-if="item.avg_comments == '暂无评价'">{{ item.avg_comments }}
                                </div>
                                <div class="team-detail-lv" v-else>{{ item.avg_comments }}%好评率</div>
                                |
                                <div class="team-detail-serve">
                                    服务人数 {{ item.serverCount }} 人
                                </div>
                                |
                                <div class="team-detail-speed">
                                    响应速度 {{item.response_speed == '暂无数据' ? item.response_speed : item.response_speed +
                                    's'}}
                                </div>
                            </div>

                            <div class="team-detail-name">
                                <div class="team-name">
                                    {{ item.company_name }}
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="600"
                                        trigger="hover">
                                    <div class="hoverImg">
                                        <img v-if="item.company_license_pic" :src="item.company_license_pic" alt="">
                                    </div>
                                    <img slot="reference" v-if="item.is_company == 1" src="@/assets/images/charter/gongsi.png" alt="">
                                </el-popover>

                                <img class="team-detail-name-img" v-if="item.is_company == 2" src="@/assets/images/charter/geren.png" alt="">
                            </div>
                            <div class="team-guarantee">
                                <div class="team-guarantee-detail" v-if="item.is_invoice">
                                    可开发票
                                </div>
                                <div class="team-guarantee-detail" v-if="item.contract">
                                    可签合同
                                </div>
                                <div class="team-guarantee-detail" v-if="item.is_insurance">
                                    含座位险
                                </div>
                            </div>
                        </div>
                        <div class="team-list-box-right"
                             @click.stop="contactBtn(item.team_id,item.mobile,item.company_pic,item.company_name)">
                            <img src="@/assets/images/charter/public_icon_lxcd_s.png" alt="">
                            <span>联系车队</span>
                        </div>
                    </div>

                    <div class="page-paging" v-show="getcdList.length">
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="currentPageChange"
                                :current-page.sync="currentPage"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="10"
                                layout="prev, pager, next, jumper"
                                :total="getcdList.length">
                        </el-pagination>
                    </div>
                </div>

                <div class="noTeamList" v-show="!getcdList.length">
                    <img :src="noTeamIcon" alt="">
                    <div class="noTeamText">没有找到相关车队</div>
                </div>
            </div>
            <div class="charter-box-right">
                <div class="box-right-first">
                    <div class="box-right-top">
                        <div class="box-right-top-left">
                            <div class="line-bold-text">精选车队推荐</div>
                            <div class="line-style"></div>
                        </div>
                        <div class="box-right-top-right">
                            TOP
                        </div>
                    </div>
                </div>

                <div class="box-right-list">
                    <div class="box-right-list-area"
                         v-for="(item,index) in getjxList"
                         :key="index"
                         @click="toTeamDetail(item.id, item.company_pic, item.company_name)"
                    >
                        <div class="right-team-ranking"
                             :class="index == 0 ? 'portrait-red' : (index == 1 ? 'portrait-active' : (index == 2 ? 'portrait-green' : ''))">
                            {{ index+1 }}
                        </div>
                        <div class="right-team-portrait">
                            <img :src="item.company_pic" alt="">
                        </div>
                        <div class="right-team-name-box">
                            <div class="right-team-name">
                                {{ item.title }}
                            </div>
                            <div class="right-team-rate">
                                <el-rate
                                        class="right-el-rate"
                                        v-model="item.star"
                                        disabled
                                        text-color="#ff9900"
                                        :colors=scoreColors
                                        disabled-void-color="#888">
                                </el-rate>
                                <div class="right-team-rate-pen">
                                    {{ typeof item.avg_comments == 'number' ? item.avg_comments + '%' :
                                    item.avg_comments }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="right-service">
                    <div class="right-service-box">
                        <div class="right-service-p">
                            我们的服务
                        </div>
                        <div class="right-service-list">
                            <div class="right-service-area" v-for="(item,index) in ourServiceList" :key="index">
                                <img :src="item.icon" alt="">
                                <div class="right-service-detail">
                                    <div class="right-service-detail-title">
                                        {{ item.title }}
                                    </div>
                                    <div class="right-service-detail-p">
                                        {{ item.content }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <home-footer></home-footer>

        <!--虚拟号弹窗-->
        <div class="showTelephone" v-show="showTelephone">
            <div class="showTelephoneBox">
                <div class="closeImg" @click="showTelephone=false">
                    <span></span>
                    <div class="showTelephoneCenter">
                        温馨提示
                    </div>
                    <span>
                        <img src="@/assets/images/charter/yuanquan.png" alt="">
                    </span>
                </div>

                <div class="tipsTextBox">
                    <img class="tipsTextBoxImg" :src="companyPic" alt="">
                    <p class="tipsTextBoxName">{{ companyName }}</p>
                    <p class="tipsText">
                        此号码为虚拟号：有限期为3分钟
                    </p>
                    <div class="tipsTextBoxPhone">
                        <img src="@/assets/images/charter/telIocn.png" alt="">
                        <span>{{ xuniTelephone }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';
    import {mapState, mapMutations, mapGetters} from 'vuex';

    const cityOptions = ['座位险', '可开发票', '可签合同'];
    export default {
        name: "charter",
        components: {
            homeNav,
            homeFooter
        },
        data() {
            return {
                typeList: [
                    {
                        text: '全部'
                    },
                    {
                        text: '7座'
                    },
                    {
                        text: '8-19座'
                    },
                    {
                        text: '20-29座'
                    },
                    {
                        text: '30-39座'
                    },
                    {
                        text: '40-55座'
                    }
                ],
                typeNumber: 0,
                serviceArea: [],
                serviceAreaNumber: 0,
                natureList: [
                    {
                        text: '全部'
                    },
                    {
                        text: '公司'
                    },
                    {
                        text: '个人'
                    }
                ],
                natureNumber: 0,

                checkAll: false,
                checkedCities: [],
                cities: cityOptions,
                isIndeterminate: true,
                selectAllCheck: false,

                morenIcon: require('@/assets/images/charter/screen_icon_moren.png'),
                jiangIcon: require('@/assets/images/charter/screen_icon_jiang.png'),
                shengIcon: require('@/assets/images/charter/screen_icon_sheng.png'),
                sortList: [
                    {
                        text: '综合排序'
                    },
                    {
                        text: '服务人数'
                    },
                    {
                        text: '好评率'
                    },
                    {
                        text: '响应速度'
                    },
                ],
                sortNumber: 0,
                downIcon: true,
                downIcon0: true,
                downIcon1: false,
                downIcon2: false,
                downIcon3: false,
                sortNumberClick: 0,
                checkArr: [],

                scoreColors: ['#FF5227', '#FF5227', '#FF5227'],
                currentPage: 1,

                teamList: [],

                showTelephone: false, //联系车队显示虚拟号弹窗
                xuniTelephone: '', //虚拟号
                companyPic: '', //头像
                companyName: '', //团队名

                noTeamIcon: require('@/assets/images/charter/null_img_bus.png'),

                rightTeamList: [],
                ourServiceList: [
                    {
                        icon: require('@/assets/images/charter/cd_icon_service01.png'),
                        title: '1对1管家式服务',
                        content: '只需一个电话或者微信，客服即会为您解除困扰'
                    },
                    {
                        icon: require('@/assets/images/charter/cd_icon_service02.png'),
                        title: '季度检验车队',
                        content: '以专业的角度看车队，每季度不定期审查车队是否合格'
                    },
                    {
                        icon: require('@/assets/images/charter/cd_icon_service03.png'),
                        title: '12小时快速维权',
                        content: '不扯皮拖拉，12小时响应，为解决行程'
                    }
                ],
                search: '',
                showInput: false,


                // 搜索框
                restaurants: [],
                state: '',
                timeout: null,
                isLogin: false,
                car_type: '',
            }
        },

        created() {
            var that = this;
        },
        mounted() {
            window.scrollTo(0, 0);
            this.showInput = false;
            var that = this;
            var city_id = this.getcityId;
            that.search = this.$route.query.search;
            that.state = this.$route.query.search;
            // 判断vuex store里是否已经有对应的城市区域内的车队 如果没有就请求
            // if (this.getcdList.length<=0 && city_id) {
            //     console.log(this.getcdList.length,city_id);
            //     that.getCharterList(city_id);
            // } else {
            //     console.log(this.getcdList.length,city_id);
            //     that.teamList = this.getcdList;
            // }

            // if(this.getjxList.length<=0 && city_id){
            //     console.log(this.getjxList.length,city_id);
            //     that.getCharterListRight(city_id);
            // } else {
            //     console.log(this.getjxList.length,city_id);
            //     that.rightTeamList = this.getjxList;
            // }

            if (city_id) {
                that.changeArea(city_id);
            };

            this.getUrl();
        },
        methods: {
            ...mapMutations(['saveCityName', 'saveCity', 'saveTeamList', 'saveCdList', 'saveJxList', 'saveCityArea']),
            getUrl(){
                var now_url = localStorage.getItem('now_url');
                if(now_url == '' || now_url == null || now_url == undefined){
                    var url = window.location.href;
                    localStorage.setItem('now_url', url);
                }
            },
            querySearchAsync(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
                cb(results);
                // clearTimeout(this.timeout);
                // this.timeout = setTimeout(() => {
                //     cb(results);
                // }, 1000 * Math.random());
            },
            createStateFilter(queryString) {
                return (state) => {
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                console.log(item);
            },
            handleIconClickCharter() {
                var that = this;
                if (that.state == undefined) {
                    return;
                }
                that.search = that.state;
                that.getCharterList(this.getcityId);
            },
            //获取车队列表init
            getCharterList(city_id) {
                var that = this;
                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                that.$axios.post('/charterList', {
                    city_id: city_id,
                    page: 1,
                    search: that.search,
                    car_type: that.car_type
                }).then((res) => {
                    loading.close();
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data);
                        // that.$store.state.teamList = res.data;
                        // that.saveTeamList({'saveTeamList': res.data});//更改数组
                        // that.teamList = res.data;
                        that.saveCdList({'saveCdList': res.data});
                    } else {
                        this.$message.error('系统错误，请刷新');
                    }
                }).catch((error) => {
                    loading.close();
                    console.log(error);
                });
            },

            //获取右侧精选车队列表
            getCharterListRight(cityId) {
                var that = this;
                that.$axios.post('/charterList', {
                    city_id: cityId,
                    page: 1,
                    search: that.search,
                    car_type: that.car_type
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data);
                        /*var ddd = res.data.slice(0, 4);
                        that.rightTeamList = ddd;*/
                        that.saveJxList({'jxList': res.data.slice(0, 4)});
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            //获取车队列表自定义参数
            getCharterListFilter(post_data) {
                var that = this;
                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                that.$axios.post('/charterList', post_data).then((res) => {
                    loading.close();
                    res = res.data;
                    if (res.status == 200) {
                        that.saveTeamList({'saveTeamList': res.data});
                        that.saveCdList({'saveCdList': res.data});
                    } else {
                        this.$message.error('系统错误，请刷新');
                    }
                }).catch((error) => {
                    loading.close();
                    console.log(error);
                });
            },

            //获取area服务区域
            changeArea(city_id) {
                var that = this;
                that.$axios.post('/cityGetArea', {
                    city_id: city_id,
                    page: 1,
                }).then((res) => {
                    res = res.data;
                    // console.log(res)
                    if (res.status == 200) {
                        that.serviceArea = [];
                        that.serviceArea.push({text: '全部'});
                        res.data.forEach((item) => {
                            that.serviceArea.push({text: item.name});
                        })
                        // that.saveCityArea({'cityArea': that.serviceArea});
                    } else {
                        this.$message.error('获取区域失败，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            // 车辆类型切换点击事件
            typeClick(idx) {
                if (idx == 1) {
                    this.car_type = 7;
                } else if (idx == 2) {
                    this.car_type = 8;
                } else if (idx == 3) {
                    this.car_type = 29;
                } else if (idx == 4) {
                    this.car_type = 39;
                } else if (idx == 5) {
                    this.car_type = 55;
                } else {
                    this.car_type = '';
                }
                this.typeNumber = idx;
                this.getCharterList(this.getcityId);
            },
            // 服务区域切换点击事件
            serviceAreaClick(idx) {
                this.serviceAreaNumber = idx;
                this.getCharterList(this.getcityId);
            },
            // 车队性质切换点击事件
            natureClick(idx) {
                this.natureNumber = idx;
            },
            /*handleCheckAllChange(val) {
                this.checkedCities = val ? cityOptions : [];
                this.isIndeterminate = false;
            },*/
            // 多选框切换事件
            handleCheckedCitiesChange(value) {
                var that = this;
                let checkedCount = value.length;
                that.checkArr = value;
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
                this.selectAllCheck = checkedCount === this.cities.length;
                //改变事件
                var zwx = '';
                var fp = '';
                that.checkArr.forEach((item) => {
                    if (item == '座位险') {
                        zwx = 1;
                    }
                    if (item == '可开发票') {
                        fp = 1;
                    }
                })
                var gsxz;
                if (that.natureNumber == 0) {
                    gsxz = '';
                } else {
                    gsxz = that.natureNumber;
                }
                if (that.sortNumberClick == 0) {
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 1) {
                    var sort_type;
                    that.downIcon1 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        serverNum: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if(that.sortNumberClick == 2) {
                    var sort_type;
                    that.downIcon2 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        PraiseRate: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if(that.sortNumberClick == 3) {
                    var sort_type;
                    that.downIcon3 ? sort_type = 'asc' : sort_type = 'desc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        response_speed: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                }
            },
            // 全选点击事件
            selectAll() {
                var that = this
                this.checkedCities = cityOptions;
                this.selectAllCheck = true;
                //改变事件
                if (this.selectAllCheck) {
                    var zwx = 1;
                    var fp = 1;
                } else {
                    var zwx = '';
                    var fp = '';
                }
                var gsxz;
                if (that.natureNumber == 0) {
                    gsxz = '';
                } else {
                    gsxz = that.natureNumber;
                }
                if (that.sortNumberClick == 0) {
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 1) {
                    var sort_type;
                    that.downIcon1 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        serverNum: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if(that.sortNumberClick == 2) {
                    var sort_type;
                    that.downIcon2 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        PraiseRate: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                } else if(that.sortNumberClick == 3) {
                    var sort_type;
                    that.downIcon3 ? sort_type = 'asc' : sort_type = 'desc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        response_speed: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        search: that.search,
                        car_type: that.car_type
                    };
                    that.getCharterListFilter(post_data)
                }
            },

            // 排序点击事件
            sortClick(idx) {
                this.sortNumber = idx;
                // this.downIcon = !this.downIcon;
                if (idx == 0) {

                } else if (idx == 1) {

                } else if (idx == 2) {

                } else if (idx == 3) {

                }
            },

            // 排序点击事件-非循环
            sortClickIdx(idx) {
                this.sortNumberClick = idx;
                if (idx == 0) {
                    this.downIcon1 = false;
                    this.downIcon2 = false;
                    this.downIcon3 = false;
                    if (this.downIcon0) {
                        this.downIcon0 = false;
                    } else {
                        this.downIcon0 = true;
                    }
                } else if (idx == 1) {
                    this.downIcon0 = false;
                    this.downIcon2 = false;
                    this.downIcon3 = false;
                    if (this.downIcon1) {
                        this.downIcon1 = false;
                    } else {
                        this.downIcon1 = true;
                    }
                } else if (idx == 2) {
                    this.downIcon0 = false;
                    this.downIcon1 = false;
                    this.downIcon3 = false;
                    if (this.downIcon2) {
                        this.downIcon2 = false;
                    } else {
                        this.downIcon2 = true;
                    }
                } else if (idx == 3) {
                    this.downIcon0 = false;
                    this.downIcon1 = false;
                    this.downIcon2 = false;
                    if (this.downIcon3) {
                        this.downIcon3 = false;
                    } else {
                        this.downIcon3 = true;
                    }
                }
            },

            // 车队列表点击事件
            teamClick(id, companyPic, teamName) {
                // CharterDetails.vue车队详情页面,CharterDetails.vue页面路由配置里的的name属性
                // this.$router.push({name: "CharterDetails", params: {id: id,teamName: teamName}})
                this.$router.push({
                    path: "/charterDetails",
                    query: {id: id, companyPic: companyPic, teamName: teamName}
                })
            },

            // 联系车队点击事件
            contactBtn(team_id, mobile, companyPic, companyName) {
                var that = this
                // that.$axios.post('/charterListDetail', {
                //     fleet_id: team_id
                // }).then((res) => {
                //     res = res.data;
                //     if (res.status == 200) {
                //         that.getXnum(res.data.team_id, res.data.mobile, companyPic, companyName)
                //     } else {
                //         layer.msg('系统错误，请刷新！', {icon: 2});
                //     }
                // }).catch((error) => {
                //     console.log(error);
                // });
                that.getXnum(team_id, mobile, companyPic, companyName)
            },
            //打电话
            getXnum(team_id, mobile, companyPic, companyName) {
                var that = this;
                var userIp = this.getuserIp;
                var url = localStorage.getItem('now_url');
                that.$axios.post('http://api.hbc1223.com/api/BindFictitious', {
                    city: this.$store.state.cityName,
                    referrer: '',
                    url: url,//当前页面url
                    info_id: userIp,//ip
                    from: '14',
                    team: team_id,
                    phone: mobile,
                    isList: '1',
                    source: '联系车队'
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        //在这里写弹出号码
                        that.showTelephone = true;
                        that.xuniTelephone = res.data;
                        that.companyPic = companyPic;
                        that.companyName = companyName;
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message.error('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            // 精选车队跳转至详情页面
            toTeamDetail(id, companyPic, teamName) {
                this.$router.push({
                    path: "/charterDetails",
                    query: {id: id, companyPic: companyPic, teamName: teamName}
                })
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            currentPageChange(val) {
                console.log(`当前页: ${val}`);
            }
        },

        computed: {
            ...mapGetters(['getcityId', 'getcdList', 'getjxList', 'getuserIp'])
        },
        watch: {
            getcityId(newVal,oldVal){
                this.changeArea(newVal);
            },
            storeteamList(newVal, oldVal) {
                var that = this
                this.teamList = JSON.parse(this.$store.state.teamList);
                // that.changeArea();
                // this.rightTeamList = [];
                // for (var i = 0; i < 4; i++) {
                //     that.rightTeamList.push({
                //         number: i + 1,
                //         img: that.teamList[i].company_pic,
                //         teamName: that.teamList[i].title,
                //         value: that.teamList[i].value,
                //         percent: that.teamList[i].avg_comments,
                //     });
                // }
            },
            sortNumberClick(newVal, oldVal) {
                var that = this
                var zwx = '';
                var fp = '';
                that.checkArr.forEach((item) => {
                    if (item == '座位险') {
                        zwx = 1;
                    }
                    if (item == '可开发票') {
                        fp = 1;
                    }
                })
                var gsxz;
                if (that.natureNumber == 0) {
                    gsxz = '';
                } else {
                    gsxz = that.natureNumber;
                }
                if (newVal == 0) {
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if (newVal == 1) {
                    var sort_type;
                    that.downIcon1 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        serverNum: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if (newVal == 2){
                    var sort_type;
                    that.downIcon2 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        PraiseRate: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if (newVal == 3){
                    var sort_type;
                    that.downIcon3 ? sort_type = 'asc' : sort_type = 'desc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        response_speed: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                }
            },
            downIcon0(newVal, oldVal) {
                //综合排序没有上下箭头
            },
            downIcon1(newVal, oldVal) {
                // console.log('排序改变')
                var that = this
                var zwx = '';
                var fp = '';
                that.checkArr.forEach((item) => {
                    if (item == '座位险') {
                        zwx = 1;
                    }
                    if (item == '可开发票') {
                        fp = 1;
                    }
                })
                var gsxz;
                if (that.natureNumber == 0) {
                    gsxz = '';
                } else {
                    gsxz = that.natureNumber;
                }
                if (that.sortNumberClick == 0) {
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 1) {
                    var sort_type;
                    that.downIcon1 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        serverNum: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 2) {
                    var sort_type;
                    that.downIcon2 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        PraiseRate: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 3) {
                    var sort_type;
                    that.downIcon3 ? sort_type = 'asc' : sort_type = 'desc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        response_speed: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                }
            },
            downIcon2(newVal, oldVal) {
                // console.log('排序改变')
                var that = this
                var zwx = '';
                var fp = '';
                that.checkArr.forEach((item) => {
                    if (item == '座位险') {
                        zwx = 1;
                    }
                    if (item == '可开发票') {
                        fp = 1;
                    }
                })
                var gsxz;
                if (that.natureNumber == 0) {
                    gsxz = '';
                } else {
                    gsxz = that.natureNumber;
                }
                if (that.sortNumberClick == 0) {
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 1) {
                    var sort_type;
                    that.downIcon1 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        serverNum: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if(that.sortNumberClick == 2) {
                    var sort_type;
                    that.downIcon2 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        PraiseRate: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if(that.sortNumberClick == 3) {
                    var sort_type;
                    that.downIcon3 ? sort_type = 'asc' : sort_type = 'desc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        response_speed: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                }
            },

            downIcon3(newVal, oldVal) {
                var that = this
                var zwx = '';
                var fp = '';
                that.checkArr.forEach((item) => {
                    if (item == '座位险') {
                        zwx = 1;
                    }
                    if (item == '可开发票') {
                        fp = 1;
                    }
                })
                var gsxz;
                if (that.natureNumber == 0) {
                    gsxz = '';
                } else {
                    gsxz = that.natureNumber;
                }
                if (that.sortNumberClick == 0) {
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 1) {
                    var sort_type;
                    that.downIcon1 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        serverNum: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if(that.sortNumberClick == 2) {
                    var sort_type;
                    that.downIcon2 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        PraiseRate: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if(that.sortNumberClick == 3) {
                    var sort_type;
                    that.downIcon3 ? sort_type = 'asc' : sort_type = 'desc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        response_speed: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                }
            },

            natureNumber(newVal, oldVal) {
                // console.log('公司性质筛选')
                var that = this
                var zwx = '';
                var fp = '';
                that.checkArr.forEach((item) => {
                    if (item == '座位险') {
                        zwx = 1;
                    }
                    if (item == '可开发票') {
                        fp = 1;
                    }
                })
                var gsxz;
                if (that.natureNumber == 0) {
                    gsxz = '';
                } else {
                    gsxz = that.natureNumber;
                }
                if (that.sortNumberClick == 0) {
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else if (that.sortNumberClick == 1) {
                    var sort_type;
                    that.downIcon1 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        serverNum: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                } else {
                    var sort_type;
                    that.downIcon2 ? sort_type = 'desc' : sort_type = 'asc';
                    var post_data = {
                        city_id: that.getcityId,
                        page: 1,
                        PraiseRate: sort_type,
                        is_company: gsxz,
                        is_insurance: zwx,
                        is_invoice: fp,
                        car_type: this.car_type,
                    };
                    that.getCharterListFilter(post_data)
                }
            },
            typeNumber(newVal, oldVal) {

            },
            serviceAreaNumber(newVal, oldVal) {

            },

        }
    }
</script>

<style scoped>
    @import './charter.css';
</style>



// WEBPACK FOOTER //
// src/pages/charter/charter.vue